import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import '@/styles/index.scss'
import { lazyLoadDirective } from '@/utils/imageUtils'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 注册图片懒加载指令
Vue.directive('lazy-load', lazyLoadDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
